import { MapPin } from "lucide-react";
import { waLink } from "@/lib/brand";

const CITIES = [
  "Florianópolis",
  "São José",
  "Palhoça",
  "Biguaçu",
];

export const ServiceArea = () => {
  return (
    <section
      data-testid="service-area-section"
      className="relative py-24 lg:py-36 bg-[#050505] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <MapPin size={18} className="text-[#facc15]" strokeWidth={1.5} />
            <span className="text-[11px] uppercase tracking-[0.32em] text-[#facc15] font-bold">
              Área de Atendimento
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-white">
            Atendemos toda a{" "}
            <span className="italic text-[#facc15]">Grande Florianópolis</span>.
          </h2>
          <p className="mt-8 text-zinc-400 leading-relaxed max-w-md">
            Especialistas em esquadrias de alumínio em Florianópolis, São José,
            Palhoça, Biguaçu e toda a Grande Florianópolis. Soluções completas
            para residências, condomínios, empresas e construtoras.
          </p>
          <a
            href={waLink("Olá! Atendem na minha região? Quero um orçamento.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="service-area-whatsapp-btn"
            className="mt-10 inline-flex items-center gap-3 px-7 py-5 border border-white/20 text-white font-bold uppercase text-[11px] tracking-[0.28em] hover:bg-[#facc15] hover:text-black hover:border-[#facc15] transition-colors"
          >
            Verificar minha região →
          </a>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <div className="grid grid-cols-2 border-t border-l border-white/10">
            {CITIES.map((c, i) => (
              <div
                key={c}
                data-testid={`city-${i}`}
                className="border-r border-b border-white/10 p-6 group hover:bg-[#0a0a0a] transition-colors"
              >
                <span className="text-xs text-zinc-600">0{i + 1}</span>
                <p className="mt-1 font-display text-lg text-white group-hover:text-[#facc15] transition-colors">
                  {c}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
